<template>
  <div>
    <base-header class="pb-8 pt-3"> </base-header>

    <b-container fluid class="mt--6">
      <b-row>
        <b-col>
          <div
            class="card card-flush shadow-sm mb-xl-8 animate__animated animate__fadeIn shadow"
          >
            <div class="card-header border-0">
              <div class="row">
                <div class="col-md-6">
                  <h3
                    class="card-title align-items-start flex-column w-lg-50 mb-0"
                  >
                    <div class="w-lg-50 col-6 px-0">
                      <div class="d-flex justify-content-end">
                        <!-- <input
                          type="text"
                          v-model="pagination.find"
                          class="form-control form-control-sm form-control-solid"
                          placeholder="Buscar nombre o rfc"
                          name="card_cvv"
                          :class="{ 'bg-light-warning': pagination.find != '' }"
                        /> -->
                        <!-- <div class="position-absolute mt-1 mr-2">
                          <i
                            v-if="pagination.find == ''"
                            class="fa fa-search text-secondary"
                          ></i>
                          <i
                            v-if="pagination.find != ''"
                            @click="pagination.find = ''"
                            class="fa fa-times-circle text-danger c-pointer"
                          ></i>
                        </div> -->
                      </div>
                    </div>
                    <!-- <span class="text-muted mt-1 fw-bold fs-7">Over 500 members</span> -->
                  </h3>
                </div>
                <div class="col-md-6 text-right">
                  <!-- <router-link
                    :to="`/catalogos/sucursales/editar-crud`"
                    class="btn btn-primary btn-sm"
                  >
                    <i class="fa fa-pencil"></i>
                  </router-link> -->
                </div>
              </div>
            </div>
            <div class="card-body py-0">
              <div class="row mb-3">
                <div class="col d-flex justify-content-end">
                  <button @click="selloModal" class="btn btn-primary btn-sm">
                    Agregar Certificado
                  </button>
                </div>
              </div>
              <div class="table-responsive">
                <table
                  class="getting table align-items-center table-flush table-sm"
                >
                  <thead class="thead-light">
                    <tr
                      class="fw-bold fs-7 text-gray-500 border-bottom border-gray-200 py-4"
                    >
                      <!-- <th class="w-25px">
                  <div class="form-check form-check-sm form-check-custom form-check-solid">
                    <input class="form-check-input" type="checkbox" value="1" data-kt-check="true" data-kt-check-target=".widget-9-check">
                  </div>
                </th> -->
                      <th class="min-w-100px">No. Certificado</th>
                      <th class="min-w-100px">Nombre</th>
                      <th class="min-w-100px">RFC</th>
                      <th class="min-w-100px">Vigencia Inicio</th>
                      <th class="min-w-100px">Vigencia Fin</th>
                      <th class="text-center">Estatus</th>
                      <!-- <th class="min-w-100px text-end">Acciones</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, kr) in elements" :key="kr" class="">
                      <td>{{ item.certificate_number }}</td>
                      <td>{{ item.issuer_business_name }}</td>
                      <td>{{ item.issuer_rfc }}</td>
                      <td>{{ item.valid_from }}</td>
                      <td>{{ item.valid_to }}</td>
                      <td class="text-center">
                        <i
                          v-if="item.is_active"
                          class="fas fa-check-circle text-success"
                        ></i>
                        <i
                          v-if="!item.is_active"
                          class="fas fa-times-circle text-danger"
                        ></i>
                      </td>
                      <!-- <td>
                        <div class="d-flex justify-content-end flex-shrink-0">
                          <button-delete
                            :cancel="item.cancel"
                            @onDelete="cancel(item)"
                          />
                        </div>
                      </td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-footer pt-2 d-flex justify-content-between">
              <!-- <div class="row">
                <label for="" class="col">Registros por página:</label>
                <select
                  v-model="pagination.limit"
                  class="col form-control form-control-sm"
                >
                  <option value="15">15</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
              <ul class="pagination">
                <li class="page-item previous">
                  <button
                    @click="pagination.page = 1"
                    :disabled="pagination.page <= 1"
                    class="page-link"
                  >
                    <i class="fas fa-angle-left"></i>
                  </button>
                </li>
                <li class="page-item">
                  <button
                    v-if="pagination.page > 2"
                    @click="pagination.page += -2"
                    class="page-link"
                  >
                    {{ pagination.page - 2 }}
                  </button>
                </li>
                <li class="page-item">
                  <button
                    v-if="pagination.page > 1"
                    @click="pagination.page += -1"
                    class="page-link"
                  >
                    {{ pagination.page - 1 }}
                  </button>
                </li>
                <li class="page-item active">
                  <a href="#" class="page-link">{{ pagination.page }}</a>
                </li>
                <li class="page-item">
                  <button
                    v-if="Math.ceil(pagination.total / pagination.limit) > 1"
                    @click="pagination.page += +1"
                    class="page-link"
                  >
                    {{ pagination.page + 1 }}
                  </button>
                </li>
                <li class="page-item">
                  <button
                    v-if="Math.ceil(pagination.total / pagination.limit) > 2"
                    @click="pagination.page += +2"
                    class="page-link"
                  >
                    {{ pagination.page + 2 }}
                  </button>
                </li>
                <li class="page-item next">
                  <button
                    @click="Math.ceil(pagination.total / pagination.limit)"
                    :disabled="
                      Math.ceil(pagination.total / pagination.limit) <= 1
                    "
                    class="page-link"
                  >
                    <i class="fas fa-angle-right"></i>
                  </button>
                </li>
              </ul> -->
            </div>
          </div>
        </b-col>
      </b-row>
      <b-modal id="modal-sello" title="Actualizar Sello">
        <b-form-group label="RFC">
          <b-form-input
            :disabled="working"
            type="text"
            id="formRFC"
            ref="formRFC"
            class="form-control-sm form-control-solid"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Certificado">
          <b-form-file
            :disabled="working"
            type="file"
            id="formCer"
            ref="formCer"
            accept=".cer"
            class="form-control-sm form-control-solid"
          ></b-form-file>
        </b-form-group>
        <b-form-group label="Llave">
          <b-form-file
            :disabled="working"
            type="file"
            id="formKey"
            ref="formKey"
            accept=".key"
            class="form-control-sm form-control-solid"
          ></b-form-file>
        </b-form-group>
        <b-form-group>
          <div class="mb-2">
            Contraseña
            <i
              v-if="showPass"
              class="far fa-eye text-danger"
              @click="showPass = false"
            ></i>
            <i
              v-if="!showPass"
              class="far fa-eye-slash"
              @click="showPass = true"
            ></i>
          </div>
          <b-form-input
            :disabled="working"
            type="password"
            id="formPass"
            ref="formPass"
            class="form-control-sm form-control-solid"
          ></b-form-input>
        </b-form-group>
        <template #modal-footer>
          <div class="d-flex justify-content-between w-100">
            <b-button variant="dark" @click="selloCancelar()">
              Cancel
            </b-button>
            <b-button
              variant="success"
              @click="selloActualizar()"
              :disabled="working"
            >
              Actualizar
            </b-button>
          </div>
        </template>
      </b-modal>
    </b-container>
  </div>
</template>
<script>
import moment from "moment";
import SucursalState from "@/components/IDBRICS/SucursalState";
import ButtonDelete from "@/components/IDBRICS/tools/ButtonDelete";

export default {
  components: {
    SucursalState,
    ButtonDelete,
  },
  data: function () {
    return {
      moment: moment,
      getting: false,
      working: false,
      elements: [],
      showPass: false,
    };
  },
  watch: {},
  computed: {},
  beforeMount() {
    this.getSellos();
  },
  methods: {
    getSellos() {
      this.getting = true;

      this.$api
        .get(`facturacion/PAC/sellos`)
        .then((response) => {
          this.elements = response.data;
        })
        .catch((e) => {
          // this.$notiflix.Report.failure(
          //   "Error Interno",
          //   "No fue posible obtener el recurso solicitado, serás dirigido al inicio y puedes intentarlo nuevamente.",
          //   "Entendido",
          //   () => {
          //     this.$router.push("/");
          //   }
          // );
        })
        .then(() => (this.getting = false));

      // this.$api
      //   .get("sucursales")
      //   .then(response => {
      //     if (response.status == 200) {
      //       this.elements = response.data;
      //     }
      //   })
      //   .catch(e => console.error(e));
    },
    selloModal() {
      this.$bvModal.show("modal-sello");
    },
    selloCancelar() {
      this.$bvModal.hide("modal-sello");
    },
    loadFileAsBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(",")[1]);
        reader.onerror = (error) => reject(error);
      });
    },
    async selloActualizar() {
      try {
        let rfc = document.getElementById("formRFC").value;
        let cer = document.getElementById("formCer").files[0];
        let key = document.getElementById("formKey").files[0];
        let pass = document.getElementById("formPass").value;

        if (cer == undefined || key == undefined) {
          this.$notiflix.Notify.failure("Seleccione Certificado y LLave");
          return;
        }

        let cer64 = await this.loadFileAsBase64(cer);
        let key64 = await this.loadFileAsBase64(key);

        let formData = new FormData();
        formData.append("rfc", rfc);
        formData.append("cer", cer64);
        formData.append("key", key64);
        formData.append("pass", pass);

        const { data } = await this.$api.post(
          `/facturacion/PAC/sellos`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        this.selloCancelar();
        this.$notiflix.Notify.success("Sello guardado correctamente.");
        this.getSellos();
      } catch (error) {
        console.log(error);
        this.$notiflix.Notify.failure(
          "Verifique los archivos/contraseña, sello no guardado."
        );
      }
    },
  },
};
</script>
